import {
  loginSuccess,
  logoutSuccess,
  createUserRequest,
  createUserSuccess,
  createUserFailure,
} from "./authSlice";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const baseUrl = process.env.REACT_APP_BASE_URL;
const API_URL_LOGIN = baseUrl + "/all/signin";
const API_URL_SIGNUP = baseUrl + "/all/signup";

export const createUserAction = (userData) => async (dispatch) => {
  try {
    dispatch(createUserRequest());

    const response = await axios.post(API_URL_SIGNUP, userData);
    const { data } = response;

    if (data.statusType === "SUCCESS") {
      dispatch(createUserSuccess(data));
      return { success: true, data };
    } else {
      return { success: false, data };
    }
  } catch (error) {
    dispatch(createUserFailure(error.message));
    return { success: false, error: error.message };
  }
};

export const login = (userData) => async (dispatch) => {
  try {
    const response = await axios.post(API_URL_LOGIN, userData);
    const { data } = response;

    if (data?.statusType === "SUCCESS") {
      secureLocalStorage.setItem("auth", JSON.stringify(data));
      secureLocalStorage.setItem("user", JSON.stringify({ user: data }));
      secureLocalStorage.setItem("token", data.token);
      secureLocalStorage.setItem("refreshToken", data.refreshToken);

      dispatch(loginSuccess(data));

      return { success: true, data };
    } else {
      return { success: false, data };
    }
  } catch (error) {
    dispatch(createUserFailure(error.message));
    console.error("Login failed:", error);
    return { success: false, error: error.message };
  }
};

export const logout = () => (dispatch) => {
  try {
    secureLocalStorage.removeItem("auth");
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("refreshToken");

    delete axios.defaults.headers.common["Authorization"];

    dispatch(logoutSuccess());
  } catch (error) {
    console.error("Logout error:", error);
  }
};
